"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandIconDefinitions = void 0;
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
exports.BrandIconDefinitions = {
    BITBUCKET_ICON: free_brands_svg_icons_1.faBitbucket,
};
